import { Stack, Text, Box } from "@chakra-ui/react";
import { SelectTimeBox } from "../UI";
import { FC } from "react";
import { Time } from "../../helper/types";

// Memoize static options outside the component
const hourOptions = Array.from({ length: 12 }, (_, i) =>
  (i + 1).toString().padStart(2, "0")
);
const minuteOptions = Array.from({ length: 60 }, (_, i) =>
  (i + 1).toString().padStart(2, "0")
);

// Render time options
const renderTimeOptions = (options: any[]) =>
  options.map((value) => (
    <option key={value} value={value}>
      {value}
    </option>
  ));

// Time input component
const CustomTimePicker: FC<{
  time: Time;
  label?: string;
  onTimeChange: (time: Time) => void;
}> = ({ time, label, onTimeChange }) => {
  const { hour, minute, ampm } = time;
  return (
    <Box display="flex" flexDir="column" alignItems="start" gap="22px" pt="8px">
      <Text fontWeight={700} fontSize="16px" lineHeight="22px">
        {label ?? "Select Time"}
      </Text>
      <Stack direction="row" spacing={4} mt={{ md: 2 }} alignItems={"center"}>
        <SelectTimeBox
          value={hour}
          placeholder="00"
          onChange={(e) => onTimeChange({ ...time, hour: e.target.value })}
        >
          {renderTimeOptions(hourOptions)}
        </SelectTimeBox>
        <Text>:</Text>
        <SelectTimeBox
          value={minute}
          placeholder="00"
          onChange={(e) => onTimeChange({ ...time, minute: e.target.value })}
        >
          {renderTimeOptions(minuteOptions)}
        </SelectTimeBox>
        <Text>:</Text>
        <SelectTimeBox
          value={ampm}
          onChange={(e) => onTimeChange({ ...time, ampm: e.target.value })}
        >
          <option value="AM">AM</option>
          <option value="PM">PM</option>
        </SelectTimeBox>
      </Stack>
    </Box>
  );
};

export default CustomTimePicker;
